import { Button, Checkbox, message, Space } from 'antd';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import * as uuid from 'uuid';
import {
  type IWidgetCsvCombination,
  type IWidgetCsvConfig,
  type IWidgetCsvField,
} from './WidgetCsvField.ts';

export interface IImportCsvOptionsButtonProps {
  onImport: (config: IWidgetCsvConfig, firstRowAsHeaders?: boolean) => void;
  showHeaderOption?: boolean;
}

function parseCsv(serialized: string): IWidgetCsvConfig | undefined {
  try {
    const rows = serialized
      .replace(/\r+/g, '')
      .split('\n')
      .map(i => i.split('\t'));

    const fields: IWidgetCsvField[] = rows[0].map((_, i) => ({
      label: `Colonna n.${i + 1}`,
      index: i,
      optionId: uuid.v4(), // Lo pregeneriamo
      order: i,
    }));

    const combinations: IWidgetCsvCombination[] = rows
      .map((row, _) => ({ values: row }))
      .filter(
        c => !isEmpty(c.values) && c.values[0] !== '' && c.values[1] !== '',
      );

    return {
      fields,
      combinations,
    };
  } catch (e: any) {
    // biome-ignore format: <tbd>
    message.error(`Si è verificato un errore nella lettura del CSV: ${e?.message ?? 'NA'}`);
    return undefined;
  }
}

export function ImportCsvOptionsButton(props: IImportCsvOptionsButtonProps) {
  const { onImport, showHeaderOption = false } = props;
  const [firstRowAsHeaders, setFirstRowAsHeaders] = useState(true);

  const importCsv = () => {
    window.navigator.clipboard
      .readText()
      .then(serialized => {
        if (!serialized) {
          message.error('Nessun CSV trovato negli appunti.');
          return;
        }
        const config = parseCsv(serialized);
        if (!config) {
          message.error("Errore durante l'importazione del CSV.");
          return;
        }
        try {
          onImport(config, firstRowAsHeaders);
          message.success('CSV importato con successo.');
        } catch (error: any) {
          // biome-ignore format: <tbd>
          message.error(error?.message ?? "Errore durante l'importazione del CSV.");
        }
      })
      .catch(error => {
        // biome-ignore format: <tbd>
        message.error('Si è verificato un errore durante la lettura degli appunti.');
      });
  };

  return (
    <Space
      direction="vertical"
      style={{ width: '100%', marginTop: '16px', marginBottom: '8px' }}
    >
      <Button type="primary" block onClick={importCsv}>
        Incolla CSV
      </Button>
      {showHeaderOption && (
        <Checkbox
          checked={firstRowAsHeaders}
          onChange={e => setFirstRowAsHeaders(e.target.checked)}
        >
          Usa la prima riga come intestazioni colonne
        </Checkbox>
      )}
    </Space>
  );
}
